import { render } from "./userDownLoad.vue?vue&type=template&id=8a00fd12&scoped=true"
import script from "./userDownLoad.vue?vue&type=script&lang=js"
export * from "./userDownLoad.vue?vue&type=script&lang=js"

import "./userDownLoad.vue?vue&type=style&index=0&id=8a00fd12&scoped=true&lang=css"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a00fd12"]])

export default __exports__